import type { OrganizationResourceListResponseApi } from '@ingenico/api-sdk-device-management-private-v2';
import { toString } from 'lodash-es';
import type { OrganizationsAuthorizations } from '../../models/OSContent.model';

/**
 * TDL:
 *
 * Consider file sections/device-management/src/lib/components/os-organizations-tab/OSOrganizationsTab.vm.ts to get only required inputs for the screen


 */

//TODO For system package and application, replace the method mapOrganizationsAuthorizedList to mapOrganizationsAuthorizedListRefactored, and adapt each screen

/**
 * Tickets expected todo this refactor:
 * https://ingenico-tech.atlassian.net/browse/MCORE-5542
 * https://ingenico-tech.atlassian.net/browse/MCORE-5551
 */
export function mapOrganizationsAuthorizedList(response: OrganizationResourceListResponseApi) {
  return {
    pagination: response.pagination,
    data: response.data.map((item) => ({
      name: toString(item.name),
      id: toString(item.id),
    })),
  };
}

export function mapOrganizationsAuthorizedListRefactored({
  data,
}: OrganizationResourceListResponseApi): OrganizationsAuthorizations {
  const relevantDataFromData = data.map(({ id }) => id);

  return {
    organizationIds: relevantDataFromData.filter(Boolean).map((id) => toString(id)),
    checkedIds: relevantDataFromData.map((id) => toString(id)),
  };
}
